import { useContext } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconCopyOutline } from '@iwoca/icons';
import { Button, Input } from '@iwoca/orion';
import { useLocation } from 'react-router';

import { ActivationContext } from '../../activation/Activation';
import { LockedButton } from '../LockedButton/LockedButton';
import { copy } from '../util/copy';

export const PayMeLink = ({
  payMeUrl,
  iconOnly = false,
}: {
  payMeUrl: string;
  iconOnly?: boolean;
}) => {
  const { isOnboarded, isLoading } = useContext(ActivationContext);
  const url = isOnboarded ? payMeUrl : 'https://iwocaPay.me/ExampleCompanyLtd';

  const currentUrl = useLocation().pathname;
  if (isLoading) return null;
  if (!isOnboarded) return <LockedButton />;

  return (
    <div className="grid grid-cols-[1fr,max-content] gap-xs">
      <Input readOnly={true} value={url} inputMode="text" />
      <Button
        className="flex gap-xs"
        type="button"
        onClick={async () => {
          await copy(payMeUrl);
          tracking.ampli.payLinkCopied({ url: currentUrl });
        }}
        title="Copy iwocaPay link"
      >
        {!iconOnly && <span className="sm:hidden">Copy link</span>}
        <IconCopyOutline />
      </Button>
    </div>
  );
};
